import { render } from "./UpgradeBillingPlan.vue?vue&type=template&id=3bbcdd9c"
import script from "./UpgradeBillingPlan.vue?vue&type=script&lang=js"
export * from "./UpgradeBillingPlan.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__